// extracted by mini-css-extract-plugin
module.exports = {"container":"PasswordReset_container__1TTHW"};